import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

var propTypes = {
    text: PropTypes.string.isRequired,
    t: PropTypes.func.isRequired
};

export var GetLocalizedText = function GetLocalizedText(_ref) {
    var text = _ref.text,
        t = _ref.t;
    return React.createElement(
        'span',
        { style: { lineHeight: 0, margin: 0 } },
        t(text)
    );
};

GetLocalizedText.propTypes = process.env.NODE_ENV !== "production" ? propTypes : {};

export default translate('translations')(GetLocalizedText);


//////////////////
// WEBPACK FOOTER
// ./node_modules/wendys-i18next/es/GetLocalizedText.js
// module id = 656
// module chunks = 0